"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../../themes/base");
var InlineNavigationWrapper = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  padding: 0 ", ";\n  position: relative;\n  align-self: stretch;\n"], ["\n  display: flex;\n  padding: 0 ", ";\n  position: relative;\n  align-self: stretch;\n"])), base_1.spacing().medium);
exports.default = InlineNavigationWrapper;
var templateObject_1;
//# sourceMappingURL=InlineNavigationWrapper.js.map